import { render } from "./DataTableSimple.vue?vue&type=template&id=f01cff1e&scoped=true"
import script from "./DataTableSimple.vue?vue&type=script&lang=js"
export * from "./DataTableSimple.vue?vue&type=script&lang=js"

import "./DataTableSimple.vue?vue&type=style&index=0&id=f01cff1e&scoped=true&lang=scss"

import exportComponent from "/var/www/production/releases/52/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f01cff1e"]])

export default __exports__